import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18n
  // i18next-http-backend
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'fr',
    debug: false, // Désactiver complètement les logs de débogage
    defaultNS: 'common',
    ns: ['common', 'header', 'footer', 'auth', 'donate', 'events', 'foundation', 'projects', 'articles'],
    initImmediate: false, // Charger les traductions immédiatement
    // Désactiver les logs de chargement des espaces de noms
    logLevel: 'error', // Ne montrer que les erreurs
    // Configuration du backend personnalisée pour désactiver les logs
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Désactiver les logs de chargement
      request: (options, url, payload, callback) => {
        // Ne rien logger
        options.headers = { 'Accept-Encoding': 'gzip' };
        fetch(url, options)
          .then(response => response.json())
          .then(data => callback(null, { status: 200, data }))
          .catch(error => callback(error, { status: 500, data: false }));
      }
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    compatibilityJSON: 'v4',
    load: 'languageOnly',
    // Désactiver les logs pour les clés manquantes
    saveMissing: false,
    saveMissingTo: 'all',
    missingKeyHandler: (lngs, ns, key) => {
      // Ne rien faire pour les clés manquantes
      return key;
    }
  });

export default i18n;
